import { transparentize } from './Colors';
import { DefaultDarkTheme } from './Theme';
export var ShadowType;
(function (ShadowType) {
    ShadowType[ShadowType["Minor"] = 0] = "Minor";
    ShadowType[ShadowType["Standard"] = 1] = "Standard";
    ShadowType[ShadowType["Major"] = 2] = "Major";
    ShadowType[ShadowType["Subtle"] = 3] = "Subtle";
    ShadowType[ShadowType["XSubtle"] = 4] = "XSubtle";
    ShadowType[ShadowType["SubtleRightBottom"] = 5] = "SubtleRightBottom";
    ShadowType[ShadowType["SubtleBottom"] = 6] = "SubtleBottom";
})(ShadowType || (ShadowType = {}));
export function boxShadow(type) {
    const shadowColor = transparentize(DefaultDarkTheme.primary, 0.85);
    switch (type) {
        case ShadowType.Minor:
            return `box-shadow: 0 5px 20px 5px ${shadowColor}, 0 0px 10px 0 ${shadowColor};`;
        case ShadowType.Standard:
            return `box-shadow: 0 10px 30px 5px ${shadowColor}, 0 0px 10px 0 ${shadowColor};`;
        case ShadowType.Major:
            return `box-shadow: 0 20px 50px 5px ${shadowColor}, 0 0px 10px 0 ${shadowColor};`;
        case ShadowType.Subtle:
            return `box-shadow: 0 5px 15px ${shadowColor};`;
        case ShadowType.XSubtle:
            return `box-shadow: 0 3px 15px ${shadowColor};`;
        case ShadowType.SubtleRightBottom:
            return `box-shadow: 7px 7px 7px ${shadowColor};`;
        case ShadowType.SubtleBottom:
            return `box-shadow: 0 13px 15px ${shadowColor};`;
    }
}
//# sourceMappingURL=Shadows.js.map